import { Component, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { OrganizationService } from '../organization.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { NgForm } from '@angular/forms';
import { VcaAlertsService } from './../../../../../../common/vca-alerts';
import { HttpUtils } from '../../../../../../common/http/http-utils';
import { RefreshSharedService } from '../../../../../refresh-shared-service';

@Component({
  selector: 'add-organization',
  providers: [
    TranslateService
  ],
  template: require('./organization-add.html')
})

export default class AddOrganization {
  @Input('isVisible') isVisible: boolean;
  @Output('onClose') selfClose = new EventEmitter();
  @ViewChild('modelBody') modelBody: ElementRef;

  private subscription: Subscription;
  private active: boolean = true;
  private formData: any;
  private isOperationInProgress: boolean = false;
  private rsService: RefreshSharedService;
  

  constructor(public organizationService: OrganizationService,
              private translateService: TranslateService,
              private alert: VcaAlertsService, private router: Router,
              private rss: RefreshSharedService) {
    translateService.use(GlobalVariables.LOCALE);
    this.rsService = rss;
  }

  reloadTree() {
      this.rsService.refresh();
      this.closeSelf();
  }

  ngOnInit() {
    console.log('init compute add organization component');
    this.formData = {};
    this.reset();
  }
  ngOnChanges(changes) {
    console.log('onChanges compute add organization component');
    this.formData = {};
    this.reset();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  cancel() {
    this.closeSelf();
  }
  // Work around until form has a reset method
  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }

  onChangeOrgName(orgName) {
    if ( orgName ) {
      this.formData.defaultOrgUrl = HttpUtils.getBaseUrl() + '/cloud/org/' + orgName; // todo append actual url
    } else {
      this.formData.defaultOrgUrl = '';
    }
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  private handleSuccess(org) {
    // this.formData = org;
    // show success message
    this.alert.success('Organization "' + this.formData.name + '" created successfully');
    /* The response only have a job id, not have an org id to redirect to.
    this.router.navigate(['/inventory/org']); */
  }

  private handleError(org, error) {
    this.logError(error, 'create organization');
    // set scroll position to top to show error messages
    this.modelBody.nativeElement.scrollTop = 0;
    // show error message
    this.alert.danger(['Failed to create organization', error], 'compute-dialog');
  }

  private save() {
    this.isOperationInProgress = true;
    this.subscription = this.organizationService.createOrg(this.preparePayloadForRest(this.formData)).subscribe(
      res => {
        this.isOperationInProgress = false;
        this.closeSelf();
        this.handleSuccess(res);
      },
      error => {
        this.isOperationInProgress = false;
        this.handleError(this.formData, error);
      },
      () => this.logOperationCompleted('create organization')
    );
  }

  private preparePayloadForRest(formData) {
    let returnObj = {
      'objectId': '',
      'name': formData.name,
      'fullName': formData.fullName,
      'description': formData.description,
      'user':
        {
          'username': formData.username,
          'password': formData.password
        }
    };
    return returnObj;
  }

  private logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }
  private logOperationCompleted(msg: string) {
    this.isOperationInProgress = false;
  }

};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/organization/add/organization-add.component.ts